import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import AuthButton from "components/base/AuthButton";
import PromptButton, { BUTTON_TYPES } from "components/base/prompt/BaseButtons";
import BasePrompt from "components/base/prompt/BasePrompt";
import CustomTitleWithInput from "components/base/CustomTitleWithInput";
import { SingleConditionRow } from "components/campaign/campaignCreation/AdditionalQuestionBar";
import { createAction, } from "utils";

import "./MerchantRemarkSettingModal.scss";

const MerchantRemarkSettingModal = ({
  show,
  closeAction,
  allAdminRemarkOptions
}) => {
  const dispatch = useDispatch();
  const [optionModalValue, setOptionModalValue] = useState({
    showDeleteModal: false,
    showUpdateModel: false,
    optionPk: null,
    optionName: null,
  });
  const [optionNameError, setOptionNameError] = useState("");

  const clearSingleOptionModal = () => {
    setOptionModalValue({
      showDeleteModal: false,
      showUpdateModel: false,
      optionPk: null,
      optionName: null,
    })
    setOptionNameError("")
  }
  useEffect(() => {
    dispatch(
      createAction('merchantAppRecords/getCurrentPageRemarkOptions')({
      })
    );
  }, [])

  const onRemoveOneOption = () => {
    if (optionModalValue?.optionPk) {
      dispatch(
        createAction('merchantAppRecords/removeRemarkOptions')({
          deleteIds: [optionModalValue.optionPk],
        })
      );
    }
    clearSingleOptionModal();
  }

  const onAddOrUpdateOneOption = () => {
    if ([undefined, null, ""].includes(optionModalValue?.optionName)) {
      setOptionNameError("Please input option name");
      return
    }
    dispatch(
      createAction('merchantAppRecords/createOrUpdateOneRemarkOption')({
        pk: optionModalValue?.optionPk,
        optionName: optionModalValue?.optionName,
      })
    );
    clearSingleOptionModal();
  }

  const renderRemarkOptionSection = useCallback(() => {
    return <div className="d-flex flex-column flex-gap-16">
      <div className="create-section-label">{"Default remark option"}</div>
      {allAdminRemarkOptions?.map((item, index) =>
        <SingleConditionRow
          customClassName="mt-0"
          title={item?.optionName || "-"}
          onEdit={() => {
            setOptionModalValue({
              showDeleteModal: false,
              showUpdateModel: true,
              optionPk: item?.pk,
              optionName: item?.optionName,
            })
          }}
          onRemove={() => {
            setOptionModalValue({
              showDeleteModal: true,
              showUpdateModel: false,
              optionPk: item?.pk,
              optionName: item?.optionName,
            })
          }} />
      )}
      <div>

        <AuthButton
          variant={'primary'}
          title={"Add Option"}
          action={() => {
            setOptionModalValue({
              showDeleteModal: false,
              showUpdateModel: true,
              optionPk: null,
              optionName: null,
            })
          }}
          customClass={"btn-back-button-common base-buttons-item"}
        />
      </div>
    </div>
  }, [allAdminRemarkOptions])

  return (
    <>
      <BasePrompt
        customClass={'merchant-remark-setting-modal'}
        show={show}
        title={'Setting'}
        description={'Create preset remarks for quick, tap-to-select input during reward processing in merchant app.'}
        closeAction={closeAction}
        otherBody={renderRemarkOptionSection}
      />
      <BasePrompt
        customClass={'merchant-remark-one-option-modal'}
        title={"Options"}
        show={optionModalValue?.showUpdateModel}
        closeAction={clearSingleOptionModal}
        otherBody={() => (
          <>
            <div>
              <CustomTitleWithInput
                title={'Option name'}
                defaultValue={optionModalValue?.optionName}
                setValue={(value) => {
                  setOptionNameError("");
                  setOptionModalValue(prev => ({
                    ...prev,
                    optionName: value,
                  }))
                }}
                error={{
                  id: 'optionName',
                  error: !!optionNameError,
                  message: optionNameError
                }}
              />
            </div>
            <div className="base-prompt-buttons">
              {
                optionModalValue?.optionPk && (
                  <AuthButton
                    variant={'primary'}
                    title={"Delete"}
                    action={() => {
                      setOptionModalValue(prev => ({
                        ...prev,
                        showUpdateModel: false,
                        showDeleteModal: true,
                      }))
                    }}
                    customClass={"btn-back-button-common base-buttons-item"}
                  />
                )
              }
              <PromptButton
                title={"Cancel"}
                action={clearSingleOptionModal}
                type={BUTTON_TYPES.secondary}
              />
              <PromptButton
                title={"Save"}
                action={onAddOrUpdateOneOption}
                type={BUTTON_TYPES.main}
              />
            </div>
          </>
        )}
      />
      <BasePrompt
        customClass={'merchant-remark-one-option-modal'}
        title={"Confirm Delete?"}
        show={optionModalValue?.showDeleteModal}
        closeAction={clearSingleOptionModal}
        leftButton={{
          text: "Cancel",
          action: clearSingleOptionModal,
        }}
        rightButton={{
          text: "Confirm",
          action: onRemoveOneOption
        }}
      />
    </>)
}

const mapPropsToState = ({ merchantAppRecords }) => ({
  allAdminRemarkOptions: merchantAppRecords.allAdminRemarkOptions,
});

export default connect(mapPropsToState)(MerchantRemarkSettingModal);